import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import useNotifier from "@saleor/hooks/useNotifier";
import React from "react";

import GrabCancelAutobookingModal from "../../OrderList/components/GrabCancelAutobookingModal";

interface ThirdPartyCancelButtonProps {
  cancelBookingData?: string | null;
  isThirdPartyPandagoAuto?: boolean;
  setIsCancelBooked: React.Dispatch<React.SetStateAction<boolean>>;
  onPandagoCancel?: (cancelReason: string) => void;
  onCancel?: () => void;
  disabled?: boolean;
  onClose?: () => void;
  hasBooking?: boolean;
  orderId?: string | null;
  refetch?: () => void;
}

const useStyles = makeStyles(
  () => ({
    buttonWidth: {
      margin: "3px",
      width: "100%"
    }
  }),
  { name: "ThirdPartyCancelButton" }
);

function ThirdPartyCancelButton(props: ThirdPartyCancelButtonProps) {
  const {
    disabled,
    orderId,
    isThirdPartyPandagoAuto,
    cancelBookingData,
    hasBooking,
    onCancel,
    onClose,
    setIsCancelBooked,
    onPandagoCancel,
    refetch
  } = props;
  const notify = useNotifier();
  const classes = useStyles(props);
  const [displayDialog, setDisplayDialog] = React.useState(false);
  const onCancelledAutobooking = () => {
    notify({
      status: "success",
      text: `Auto-booking cancelled successfully`
    });
    onClose();
    refetch();
  };
  return (
    <>
      <GrabCancelAutobookingModal
        orderId={orderId}
        displayDialog={displayDialog}
        onClose={() => setDisplayDialog(false)}
        onSaved={onCancelledAutobooking}
        title="Cancel Auto-booking"
        content="This order has been auto-booked.
        Are you sure you want to cancel the booking?"
        isForSavingCancelAutobooking={true}
      />
      <Button
        id="cancelBookingBtn"
        className={classes.buttonWidth}
        onClick={() => {
          if (hasBooking) {
            setDisplayDialog(true);
          } else if (isThirdPartyPandagoAuto) {
            setIsCancelBooked(true);
            if (cancelBookingData !== "") {
              onPandagoCancel(cancelBookingData);
              onClose();
            }
          } else {
            onCancel();
            onClose();
          }
        }}
        disabled={disabled}
        variant="outlined"
        color="primary"
      >
        CANCEL BOOKING
      </Button>
    </>
  );
}

export default ThirdPartyCancelButton;
